import {
  surveyEditorRoot,
  surveyListRoot,
  surveyTemplateEditorRoot,
  surveyTemplateListRoot,
} from '../routes/paths';
import { SURVEY_TYPE, TEMPLATE_TYPE } from './EntityTypeList';

export default {
  [SURVEY_TYPE]: {
    item: surveyEditorRoot,
    list: surveyListRoot,
  },
  [TEMPLATE_TYPE]: {
    item: surveyTemplateEditorRoot,
    list: surveyTemplateListRoot,
  },
};
